import { Pipe, PipeTransform } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { Observable, first, map, of } from 'rxjs';

@Pipe({
  name: 'roleRestriction',
})
export class RoleRestrictionPipe implements PipeTransform {
  constructor(public fireAuth: AngularFireAuth) {}

  transform(value: string[] | undefined): Observable<boolean> {
    if (value === undefined || value.length === 0) return of(true);
    return this.fireAuth.idTokenResult.pipe(
      first(),
      map((claims: any) => {
        return value.some((r: string) => r === claims.claims?.role);
      })
    );
  }
}
